module.exports = __webpack_public_path__ + "static/media/stores-200x200.10a929b5.png";